// extracted by mini-css-extract-plugin
export default {"wrapper":"IssueBanner_wrapper__86KFv","infoText":"IssueBanner_infoText__2z2SR"};